import Home from './Home.jsx';

export {
  Home
}




// WEBPACK FOOTER //
// ./components/home/index.js